export enum RefundPolicyCode {
    notDefined = 'not_defined',
    flexible = 'flexible',
    moderate = 'moderate',
    strict = 'strict',
    noRefunds = 'no_refunds',
    custom = 'custom',
}

export type RefundPolicyCodeWithoutValidityDays =
    | RefundPolicyCode.notDefined
    | RefundPolicyCode.noRefunds
    | RefundPolicyCode.custom;

export type RefundPolicyConfig =
    | {
          refundPolicyCode: Exclude<
              RefundPolicyCode,
              RefundPolicyCodeWithoutValidityDays
          >;
          refundPolicyValidityDays: number;
      }
    | {
          refundPolicyCode: RefundPolicyCodeWithoutValidityDays;
          refundPolicyValidityDays: null;
      };
